import { render, staticRenderFns } from "./189.vue?vue&type=template&id=2ff1a524&scoped=true&"
var script = {}
import style0 from "./189.vue?vue&type=style&index=0&id=2ff1a524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1a524",
  null
  
)

export default component.exports